import React from 'react';
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import { Navigate } from "react-router-dom";
import { sessionExpiredMsg } from '../../utils/constants';
import './index.scss';

class SessionRefresh extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isRefreshClicked: false
        }
    }

    onRefreshClick = () => {
        this.setState({
            isRefreshClicked: true
        })
    }
    render() {
        const { open, close } = this.props;
        const { isRefreshClicked } = this.state;
        if (isRefreshClicked) {
            return <Navigate to='/home' />;
        }
        return (
            <div>
                <Dialog
                    onClose={close}
                    aria-labelledby="simple-dialog-title"
                    open={open}
                >
                    <div className='refresh-popup-body'>
                        <DialogTitle id="simple-dialog-title">Session expired!</DialogTitle>

                        <p className='refresh-popup-text'>
                            {sessionExpiredMsg}
                        </p>
                        <div className='refresh-popup-buttons'>
                            <button className="refresh-button"
                                onClick={this.onRefreshClick} >
                                <i aria-hidden="true" />
                               Refresh
                           </button>
                        </div>
                    </div>
                </Dialog>
            </div>
        )
    }
}
export default SessionRefresh;